import { Image } from '@valbuild/next';
import HotspotImage from '../HotspotImage';

export interface PageHeaderProps {
  header: string;
  subheader: string;
  image?: Image | null;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  header,
  subheader,
  image,
}) => {
  return (
    <div className="w-full">
      <div className="flex flex-col tablet:flex-row-reverse justify-between gap-32 tablet:gap-128 mb-128">
        <h1 className="text-lg tablet:text-xl shrink-0">{header}</h1>
        <h2 className="font-respira text-respira-lg tablet:text-respira-xl text-pretty">
          {subheader}
        </h2>
      </div>
      {image && (
        <div className="relative overflow-hidden h-full w-full max-xl-content">
          <HotspotImage
            priority={true}
            image={image}
            setAspectRatio={'aspect-[3/4] tablet:aspect-[23/10]'}
            sizes={
              '(max-width: 768px) 768px, (max-width: 1920px) 100vw, 1872px'
            }
          />
        </div>
      )}
    </div>
  );
};

export default PageHeader;
